export default function removeTypenameDeep(value: any): any {
  if (Array.isArray(value)) {
    return value.map(removeTypenameDeep);
  }
  if (value !== null && typeof value === 'object') {
    const result: any = {};
    Object.entries(value).forEach(([key, val]) => {
      if (key !== '__typename') {
        result[key] = removeTypenameDeep(val);
      }
    });
    return result;
  }
  return value;
}
